<template>
  <div id="groups" class="fixed-content">
    <page-section title="Groupes de travail" :header="require('@/assets/demo.jpg')">
      <div class="row introduction text-justify">
        <div class="col-xs-12 col-md-8 col-md-push-2">
          <p>
            <img class="img-responsive logo"
                 :src="require('@/assets/img/groups/logo-ppp.png')"/>
          </p>
          <p>
            En 2026, le groupe « Patient Partenaire Particulier » poursuit ses
            travaux avec la finalisation et le test d’un outil pédagogique
            (triptyque de petit format) destiné aux patients futurs porteurs de
            PICCline et visant à les sensibiliser au risque infectieux.
            Il sera complété d’un guide destiné aux professionnels de santé pour les
            aider à utiliser l’outil.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <p>
            <img class="img-responsive"
                 :src="require('@/assets/img/groups/planning-ppp-1.png')"/>
          </p>
        </div>
        <div class="col-xs-12 col-md-6">
          <p>
            <img class="img-responsive"
                 :src="require('@/assets/img/groups/planning-ppp-2.png')"/>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <hr>
        </div>
      </div>
      <div class="row introduction text-justify">
        <div class="col-xs-12">
          <p>
            <img class="img-responsive logo"
                 :src="require('@/assets/img/groups/logo-success.png')"/>
          </p>
        </div>
        <div class="col-xs-12 col-md-8 col-md-push-2">
          <p>
            En 2026, le groupe Success SPIADI poursuit ses travaux pour
            identifier les freins à la participation aux trois volets de
            celui-ci.
          </p>
          <p>
            L’analyse qualitative des entretiens réalisés cet été sera
            complétée par des données quantitatives obtenues à l’aide
            d’un questionnaire adressé à un plus grand nombre
            d’hygiénistes au cours du 1er trimestre 2026.
          </p>
          <p>
            L’ensemble des données analysées et des propositions
            formulées sera discuté avec le groupe de travail pour faire
            évoluer le programme Spiadi.
          </p>
        </div>
        <div class="col-xs-12">
          <div>
            <p>
              <img class="img-responsive"
                   :src="require('@/assets/img/groups/planning-success.png')"/>
            </p>
          </div>
        </div>

      </div>
    </page-section>
  </div>
</template>

<script>
import pageSection from '@/components/pagesection'

export default {
  name: 'groups',

  data () {
    return {
    }
  },

  components: {
    'page-section': pageSection
  }
}
</script>

<style scoped lang="less">
@import '~variables';

.introduction {
  font-size: 140%;

  img {
    margin: auto;
  }
}

.logo {
  max-width: 300px;
}

</style>
